import { useEffect } from 'react';
import { useHistory, useRouteMatch } from 'react-router';
import { getSpeakingItem, updateSpeakingItem } from '../../../api/speaking.api';
import ErrorResponse from '../../../components/ErrorResponse';
import Loader from '../../../components/Loader';
import useAxios from '../../../hooks/useAxios';
import {
  IGetSpeakingItem,
  ISpeakingItem,
} from '../../../models/speaking.model';
import Header from '../../../components/layout/Header';
import SpeakingItemEditor from '../../../components/cbt/speaking-item/Editor';
import useNotification from '../../../hooks/useNotification';
import { useTranslation } from 'react-i18next';

interface IMatch {
  id: string;
}

const CbtSpeakingItemEdit = () => {
  const { t } = useTranslation();
  const match = useRouteMatch<IMatch>();
  const evaluationItemCode = Number(match.params.id);
  const history = useHistory();
  const { successNotification } = useNotification();
  const { data: res, isLoading, error, execute } = useAxios<IGetSpeakingItem>();
  const {
    data: updateRes,
    isLoading: updateIsLoading,
    error: updateError,
    execute: updateExecute,
  } = useAxios();

  useEffect(() => {
    execute(getSpeakingItem(evaluationItemCode));
  }, []);

  useEffect(() => {
    if (updateRes && !updateIsLoading) {
      successNotification(t('common.message.edit1'));
      history.push('/cbt/speaking-item');
    }
  }, [updateRes, updateIsLoading]);

  const onSubmit = (req: ISpeakingItem) => {
    updateExecute(updateSpeakingItem(evaluationItemCode, req));
  };

  return (
    <div className="content-wrapper">
      {isLoading || updateIsLoading ? <Loader /> : null}
      <ErrorResponse error={error} />
      <ErrorResponse error={updateError} />
      <Header parentMenu="CBT" currentMenu={t('cbt.speakingItem.5')} />

      <div className="main max-w1200p">
        <SpeakingItemEditor speakingItem={res?.data} onSubmit={onSubmit} />
      </div>
    </div>
  );
};

export default CbtSpeakingItemEdit;
